/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useEffect, useMemo, useRef, useState } from "react";
import { modalAnatomy as parts } from "@chakra-ui/anatomy";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Tooltip,
  Box
} from "@chakra-ui/react";

import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import "rsuite/dist/rsuite.min.css";
import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from "@chakra-ui/styled-system";

import { createOption } from "../createableSelect";
import PaymentInfoComponent from "../paymentInfoComponent";
import CustomSelect from "components/CustomSelect";
import { useFormik } from "formik";
import { useToasts } from "react-toast-notifications";
import { useDispatch, useSelector } from "react-redux";
import { poNumberFormate,checkApprovalAmount,checkTotalApprovedAmountWithSpentAmount } from "jsFunctions/helperFunctions";
import { fetchAsyncGetPONumDirectTaxExpense,fetchAsyncUploadDirectPdf,fetchAsyncUpdateDirectTaxExpense ,fetchAsyncAddDirectTaxInvoiceRemark,fetchAsyncDeleteDirectPdf,fetchAsyncRejectDirectTaxTotalPayAmount,fetchAsyncApproveDirectTaxTotalPayAmount,fetchAsyncSendRequestApprovalDirectTaxTotalPayAmount,fetchAsyncDeleteDirectTaxPaymentListItem,fetchAsyncSendRequestUpdateApprovalDirectTaxTotalPayAmount,fetchAsyncDeleteDirectTaxRefundListItem} from "redux/directTaxSlice";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { InputGroup,Tab, Tabs } from "react-bootstrap";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import RefundInfoListComponent from "../refundListInfoComponent";
import QuotationForm from "../seprateFormComponent/quatationForm";
import { FaCheck, FaFileUpload, FaPlusCircle } from "react-icons/fa";
import { fetchAsyncGetAllQuotation } from "redux/quotationSlice";
import DownloadExcelFile from "../DownloadExcel/downloadExcel";
import DirectTaxDataChangeModal from "components/models/DataChange/directTaxDataChangeModal";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { getOptionDataOnEdit } from "jsFunctions/calculateGst";
import { spentAmountValidate } from "validation/spentAmount";
import { refundAmountValidate } from "validation/refundAmount";
import AmountPopover from "../amountPopover/addAmountPopover";
import prJson from "components/jsonData/purchase.json";
import commonJson from "components/jsonData/common.json";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import { RiFileDownloadLine } from "react-icons/ri";
import InvoiceComponent from "../seprateFormComponent/InvoiceComponent";
import { sumOfPaymentRecordAmount,sumOfRefundAmount } from "utiils/halper";
import useFormOptions from "hooks/FormOptions/useFormOptions";
import DatePickerField from "../component/datePickerField";
import AmountInputField from "../component/amountField";
import TextAreaField from "../component/textAreaField";
import SubmitButton from "../component/buttons/submitButton";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const xl = defineStyle({
  px: "6",
  py: "2",
  fontSize: "xl",
});

const sm = defineStyle({
  fontSize: "sm",
  py: "6",
});

const sizes = {
  xl: definePartsStyle({ header: sm, dialog: xl }),
};

export const modalTheme = defineMultiStyleConfig({
  sizes,
});

const DirectTax = ({
  openModal,
  closeModal,
  isEditForm = false,
  editItem,
  refreshEditData,
  activeList,
  role,
  expenseType
}) => {
  const dispatch = useDispatch();
  const dateRange = useSelector((state) => state.dateRange); 
  const { startDate } = dateRange;
  const [getPoMonth, setGetPoMonth] = useState("");
  const [generatedNum, setGeneratedNum] = useState("PR-DT-");
  const [isEdit, setIsEdit] = useState(isEditForm)
  const [editData, setEditData] = useState(editItem)
  const [poPrefix, setPoPrefix] = useState({
    prfx: "PR-DT-",
    m: new Date().getMonth() + 1,
    y: new Date().getFullYear(),
    n: 1,
  });
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [approveOrRejectRemarks, setApproveOrRejectRemarks] = useState('')
  const [totalPaymentAmount, setTotalPaymentAmount] = useState(0);
  const [approvalAmount, setApprovalAmount] = useState('');
  const [paymentStatus, setPaymentStatus] = useState(0);
  const [isLoading, setIsLoading] = useState(false)
  const [isBlink, setIsBlink] = useState(false)
  const [activeTab, setActiveTab] = useState('')
  const [multipleAddPaymentInfo, setMultipleAddPaymentInfo] = useState([]);
  const [multipleInvoiceData, setMultipleInvoiceData] = useState([]);
  const [billNumber, setBillNumber] = useState("");
  const [todayDate, setTodayDate] = useState(new Date());
  const [receiverValue, setReceiverValue] = useState("");
  const [totalTax, setTotalTax] = useState("");
  const [multipleAddRefundInfo, setMultipleAddRefundInfo] = useState([""]);
  const [refundAmountError, setRefundAmountError] = useState([{}]);
  const [isRefund, setIsRefund] = useState(false);
  const [compareDataModal, setCompareDataModal] = useState(false);
  const [comparingData, setComparingData] = useState(null);
  const { addToast } = useToasts();
  const [roundOfAmount, setRoundOfAmount] = useState("")
  const [spentAmountError, setSpentAmountError] = useState([{}]);
  const [remarksValue, setRemarksValue] = useState('');
  const [errors, setErrors] = useState({})

  const [openQuotation, setOpenQuotation] = useState(false)

  const [quotationData, setQuotationData] = useState({
    remarks:"",
    amount:"",
    files:""
  })

  const [allQuotation,setAllQuotation] = useState([])

  const {
    formOptionsList,
    receiverOption,
    createNewFormOption,
    deleteFormOption,
    editFormOption,
  } = useFormOptions(expenseType);

  const finalRef = useRef(null);
  const closeComparedDataModal = () => {
    setCompareDataModal(false);

    setComparingData(null);
  };

  const totalSpentAmount = useMemo(() => {
    if (multipleAddPaymentInfo) {
      if (multipleAddPaymentInfo.length > 0) {
        const total = sumOfPaymentRecordAmount(multipleAddPaymentInfo || [])
        const totalRefund = sumOfRefundAmount(multipleAddRefundInfo || [])

        return parseFloat(total) - parseFloat(totalRefund); 
      }
    }
    return 0;
  }, [multipleAddPaymentInfo,multipleAddRefundInfo]);

  const remainingAmount = useMemo(() => {
    if (multipleAddPaymentInfo) {
        const total = sumOfPaymentRecordAmount(multipleAddPaymentInfo || [])
        return parseFloat(totalPaymentAmount) -  parseFloat(total); 
    }
    return 0;
  }, [multipleAddPaymentInfo,totalPaymentAmount]);

  const initialValues = {
    poNo: "",
    orderMonth: "",
    orderDate: "",
    receiverName: "",
    remarks: "",
    totalTax: "",
    payee: 0,
    paymentAmount: 0,
    approvalAmount: 0,
    bank: "",
    referance: "",
    date: null,
    invoice: "",
  };


  useEffect(() => {
  if(!isEdit){
    setTimeout(() => {
      setIsBlink(true)
    }, 3000); 
    setTimeout(() => {
      setIsBlink(false);
    }, 4000); 
  }
}, []);

  const startOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
  const endOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0); 
useEffect(()=>{
  if(startDate && !isEdit){
    const formattedMonth = moment(startDate).format("YYYY-MM");
    setGetPoMonth(formattedMonth);
   
  }
  else{
    setGetPoMonth(moment().format("yyyy-MM"))
  }
  
},[startDate])

useEffect(()=>{
  if(getPoMonth && !isEdit){
    const formattedMonth = moment(getPoMonth).format("YYYY-MM");
    setGetPoMonth(formattedMonth);
    if (moment(formattedMonth).isSame(moment(), 'month')) {
      const creditDate = moment().toDate(); 
      setSelectedDate(creditDate); 
    }
    else{

      const firstDayOfMonth = moment(formattedMonth).startOf('month').toDate();
      setSelectedDate(firstDayOfMonth);
    }
  }
  
},[getPoMonth])

const getFormData = (values)=>{
  let formData = new FormData();
  formData.append("poNo", JSON.stringify(poPrefix));
  formData.append("orderMonth", getPoMonth);
  formData.append("roundOfAmount", roundOfAmount);
  formData.append("orderDate", todayDate);
  formData.append("billNumber", billNumber);

  formData.append("receiverId", receiverValue?.id || "");
  formData.append("receiverName", receiverValue?.label || "");

  formData.append("remarks", remarksValue);
  formData.append("isRefund", isRefund);
  const filteredMultipleAddRefundInfoPay = multipleAddRefundInfo.filter((item) => item?.amt);
  formData.append("refundInfo", JSON.stringify(filteredMultipleAddRefundInfoPay));
  formData.append("totalPaymentAmount", totalPaymentAmount);
  formData.append("totalTax", totalTax);
  formData.append("approvalAmount", approvalAmount);

  if(quotationData  && (quotationData?.files?.length > 0 || quotationData?.remarks)){
    formData.append('quotation_remarks', quotationData?.remarks);
   formData.append('quotation_amount', quotationData?.amount);
   Array.from(quotationData?.files).forEach((file) => {
       formData.append('quotation_files', file);
   });
  }
  formData.append("approveRejectRemarks", approveOrRejectRemarks);
  const filteredInvoice = multipleInvoiceData?.filter((item) => item?.file);     
  formData.append("invoiceData", JSON.stringify(filteredInvoice));
  filteredInvoice.forEach((inv, idx) => {
   formData.append(`invoiceFiles[${idx}]`, inv.file);
 });
 
  return formData;

}

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      if (!receiverValue || !totalTax) {
        setErrors({
          ...errors,
          receiverValue:prJson.required.receiverName,
          totalTax:prJson.required.totalTax
        })
        return;
      }

     
      const spentError = spentAmountValidate(
        multipleAddPaymentInfo,remainingAmount
      );
      if (Object.keys(spentError).length !== 0) {
        setSpentAmountError(spentError)
        if(activeTab && activeTab !== 'spent'){
          addToast(prJson.error.checkSpent, { appearance: "error" });
        }
        return;
      }
      const checkApproval = checkApprovalAmount(
        approvalAmount,
      );
      if (!checkApproval.status) {
        setErrors({
          ...errors,
          approvalAmount:checkApproval.msg
        })         
        return;
      }
      const filteredMultipleAddPaymentInfo = multipleAddPaymentInfo.filter((item) => item?.amt);

      const checkValid = checkTotalApprovedAmountWithSpentAmount(
        totalPaymentAmount,
        filteredMultipleAddPaymentInfo
      );
      if (!checkValid.status) {
        setErrors({
          ...errors,
          approvalAmount:checkValid.msg
        })
        return;
      }
      if(isRefund){
        const refundError = refundAmountValidate(
          multipleAddRefundInfo,remainingAmount
        );
        if (Object.keys(refundError).length !== 0) {
          setRefundAmountError(refundError)
          if(activeTab !== 'refund'){
            addToast(prJson.error.checkRefund, { appearance: "error" });
          }
          return;
        }
        }
      let formData = getFormData(values);

      const filteredMultipleAddPaymentInfoPay = filteredMultipleAddPaymentInfo.map((item)=>{
        if(item?.inv){
          return {
            ...item,
            inv: item?.inv.filter(entry => 'Key' in entry)
          }
        }
        else{
          return item
        }
      });
      formData.append("payInfo", JSON.stringify(filteredMultipleAddPaymentInfoPay));
      
      if (isEdit) {
        setComparingData(formData);
      }
    },
  });



  const handleDeleteInvoiceOnEdit = (key,spId) => {
    ConfirmationDialog({
      title: prJson.confirm.invoice,
      text: `Delete File ${key}`,
      icon: "warning",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        setIsLoading(true)

        const sendData = {
          id: editData._id,
          key: key,
          spId: spId || ""
        };
        dispatch(fetchAsyncDeleteDirectPdf(sendData)).then((res) => {
          if(res?.payload?.directTaxExpense?.pyInfo?.inv){
            setMultipleInvoiceData(res?.payload?.directTaxExpense?.pyInfo?.inv)
            addToast(prJson.success.deletedInvoice, { appearance: "success" });
            setIsLoading(false)
          }
          else{
            setIsLoading(false)
            addToast(prJson.error.generic, { appearance: "error" });
          }

        }).catch((error) => {
          addToast(prJson.error.generic, { appearance: "error" });
          setIsLoading(false);
      });
      },
    });
   
  };





  useEffect(() => {
    setGeneratedNum(poNumberFormate(poPrefix));
  }, [poPrefix]);

  useEffect(() => {
    if (!isEdit && getPoMonth) {
      const dataSplit = getPoMonth.split("-");
      dispatch(
        fetchAsyncGetPONumDirectTaxExpense({
          month: dataSplit[1],
          year: dataSplit[0],
        })
      )
        .then((res) => {
          if (res.payload?.[0]?.poNo) {
            setPoPrefix((prev) => {
              return {
                prfx: prev.prfx,
                m: dataSplit[1],
                y: dataSplit[0],
                n: res.payload?.[0]?.poNo.n + 1,
              };
            });
          } else {
            setPoPrefix((prev) => {
              return {
                prfx: prev.prfx,
                m: dataSplit[1],
                y: dataSplit[0],
                n: 1,
              };
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [getPoMonth]);


  const handleInvoiceChange = (data) => {
    if(multipleInvoiceData){
      if (multipleInvoiceData?.length < 5) {
       setMultipleInvoiceData([
         ...multipleInvoiceData,
         {
           spId:"",
           Key:"",
           remark:"",
           file:""
         },
       ])
    }
   }
  };
  const handelDeleteInvoice = (index,id) => {
    if(multipleInvoiceData){
      let invoices = multipleInvoiceData.filter((item, i) => i !== index)
      setMultipleInvoiceData(invoices);
    }
  };
  const handleUpdateInvoiceData = (invoiceData, index) => {
    const newData = [...multipleInvoiceData];
    newData[index].file = invoiceData;
    setMultipleInvoiceData(newData);
  };
  const handleAddInvoiceRemarks = (value, index) => {
    const newData = [...multipleInvoiceData];
    newData[index].remark = value
    setMultipleInvoiceData(newData);
  };
  const addNewInvoiceOnEdit = (file, index) => {
    ConfirmationDialog({
      title: prJson.confirm.uploade,
      text: `Upload - ${file.name}`,
      icon: 'warning',
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      onConfirm: () => {
        setIsLoading(true)

        if (editData) {
          let formData = new FormData();
          formData.append("poNo", JSON.stringify(editData.poNo));
          
          formData.append("file", file);
          formData.append("index", index);

          dispatch(
            fetchAsyncUploadDirectPdf({ id: editData._id, formData })
          ).then((res) => {
            if(res?.payload && res?.payload?.directTaxExpense?.pyInfo?.inv){
              setMultipleInvoiceData(res?.payload?.directTaxExpense?.pyInfo?.inv)
              refreshEditData();
              setIsLoading(false)
              addToast(prJson.success.uploaded, { appearance: "success" });
            }
            else{
              setIsLoading(false);
              addToast(prJson.error.generic, { appearance: "error" });
            }
          }).catch((error) => {
            addToast(prJson.error.generic, { appearance: "error" });
            setIsLoading(false);
        });
        }
      },
    });
  };
  // payment info function
  const handleMultiplePayInfo = (data) => {
    setMultipleAddPaymentInfo([
      ...multipleAddPaymentInfo,
      {
        amt:remainingAmount,
        pmtDt:new Date()
      },
    ]);
  };

  
  const handleUpdateMultiplePayData = (payData, index) => {
    const updateList = multipleAddPaymentInfo.map((item, i) => {
      if (i === index) {
        return {...item,...payData};
      } else return item;
    });
    const sum = updateList.reduce((acc, current) => {
      if (current?.amt && current?.amt !== '') {
        return acc + parseFloat(current?.amt);
      } else {
        return acc;
      }
    }, 0);  

    const remaning = parseFloat(totalPaymentAmount) - parseFloat(sum)
    const spentError = spentAmountValidate(
      updateList,
      remaning
    );
    if (spentError) {
      setSpentAmountError(spentError)
    }
    setMultipleAddPaymentInfo([...updateList]);
  };

 
  // 
  // Changes on Edit
  const editFormPrefiledData = (formOptionsList, editData) => {
    const resourceData = getOptionDataOnEdit(
      formOptionsList,
      editData?.rcId?._id,
      "receiver"
    );
    if (resourceData) {
      setReceiverValue({
        label: resourceData.lab,
        value: resourceData.val,
        id: resourceData?._id

      });
    }
   
  };
 

  const handleMultipleRefundInfo = (data) => {
    setMultipleAddRefundInfo([
      ...multipleAddRefundInfo,
      { paydata: data.data },
    ]);
  };
  const handleUpdateMultipleRefundData = (payData, index) => {
    const updateList = multipleAddRefundInfo.map((item, i) => {
      if (i === index) {
        return {...item,...payData};
      } else return item;
    });
    const refundError = refundAmountValidate(
      updateList,
      remainingAmount
    );
    if (refundError) {
      setRefundAmountError(refundError)
    }
    setMultipleAddRefundInfo([...updateList]);
  };

  const handleQuotationData = (data)=>{
    setQuotationData(data)
  }
  const handleCloseQuotation = ()=>{
    setOpenQuotation(!openQuotation)
    if (isEdit && editData) {
    getAllQuotation(editData?._id)
    }
  }

  const getAllQuotation = async(_id)=>{
    await dispatch(fetchAsyncGetAllQuotation(_id)).then((res)=>{

        if(res?.payload){
            const quotations = res.payload?.quotations;
            setAllQuotation(quotations)
        }
        }).catch((err)=>{
          console.log(err)
        })
}

useEffect(()=>{
  if (formOptionsList?.length > 0 && editData) {
    editFormPrefiledData(formOptionsList, editData);
  }
},[formOptionsList,editData]);
  useEffect(() => {
   
    if (isEdit && editData) {
      getAllQuotation(editData?._id)

      setPoPrefix(editData.poNo);
      setTodayDate(new Date(editData.oDt));
      setSelectedDate(new Date(editData.oDt));

      setGetPoMonth(
        `${editData.poNo.y}-${
          editData.poNo.m <= 9
            ? "0" + editData.poNo.m
            : editData.poNo.m
        }`
      );
    
      if (editData.pyInfo?.tlAmt) {
        setTotalPaymentAmount(editData.pyInfo?.tlAmt);
      }
      if (editData.pyInfo?.sts) {
        setPaymentStatus(editData.pyInfo?.sts)
      }
      if (editData.rfdInfo?.list && editData.rfdInfo?.list.length > 0) {
        setMultipleAddRefundInfo(editData.rfdInfo?.list);
      }
      if (editData?.rfdInfo && editData?.rfdInfo?.sts) {
        setIsRefund(editData?.rfdInfo?.sts);
      }

      if (editData?.rmks) {
        setRemarksValue(editData?.rmks)
      }
      if (editData?.tlTx) {
        setTotalTax(editData?.tlTx)
      }
      if (editData?.acRmks) {
        setApproveOrRejectRemarks(editData?.acRmks)
      }
      if (editData?.roAmt) {
        setRoundOfAmount(editData?.roAmt)
      }
     
      if (editData.pyInfo?.apAmt) {
        setApprovalAmount(editData.pyInfo?.apAmt);
      }
      if(editData.pyInfo?.inv && editData.pyInfo?.inv?.length > 0) {
        setMultipleInvoiceData(editData.pyInfo?.inv);
      }
      if (editData.pyInfo?.list && editData.pyInfo?.list.length > 0) {
        setMultipleAddPaymentInfo(editData.pyInfo?.list);
      }
      if (editData?.pyInfo?.blNo) {
        setBillNumber(editData?.pyInfo?.blNo || "")
      }
      else if(editData.pyInfo?.list && editData.pyInfo?.list?.length > 0) {
        setBillNumber(editData.pyInfo?.list[0]?.blNo || "");
      }
    
    }
  }, [isEdit, editData]);



  const submitUpdateData = (formData, editData) => {
    setIsLoading(true)

    dispatch(
      fetchAsyncUpdateDirectTaxExpense({
        id: editData._id,
        data: formData,
      })
    )
      .then((res) => {
        if (res.payload) {
          const msg = prJson.confirm.updatePurchase.replace("{generatedNum}", generatedNum);
          addToast(msg, { appearance: "success" });
          setIsLoading(false)
        }
        closeModal('approved');
        setComparingData(null);
        formik.resetForm();
        setIsLoading(false)

      })
      .catch((error) => {
        console.log(error);
        addToast(prJson.error.generic, { appearance: "error" });
      });
  };

  // add Remark for Invoice
  const addRemarkForInvoice = (value,index) => {
    dispatch(
      fetchAsyncAddDirectTaxInvoiceRemark({
        id: editData._id,
        remarkData: {remark: value, index },
      })
    ).then((res) => {
      setMultipleAddPaymentInfo(res?.payload?.directTaxExpense?.pyInfo?.inv)
      refreshEditData();
    });
  };

  const handleAmountApproveBtn = (values)=>{   
    if(!isEdit){
  
      if (!receiverValue || !totalTax) {
        setErrors({
          ...errors,
          receiverValue:prJson.required.receiverName,
          totalTax:prJson.required.totalTax
        })       
         return;
      }
    }
     
  

    const checkApproval = checkApprovalAmount(
      approvalAmount,
    );
    if (!checkApproval.status) {
      setErrors({
        ...errors,
        approvalAmount:checkApproval.msg
      }) 
      return;
    }
  
    if(approvalAmount <= totalPaymentAmount && remainingAmount >= 0){
  
      const checkValid = checkTotalApprovedAmountWithSpentAmount(
        totalPaymentAmount,
        multipleAddPaymentInfo
      );
      if (!checkValid.status) {
        setErrors({
          ...errors,
          approvalAmount:checkValid.msg
        })   
        return;
      }
    }
    if(remainingAmount < 0 && approvalAmount <= totalPaymentAmount){
      return;
    }
      let formData = getFormData(values);
      
      if(isEdit && editData){
        setIsLoading(true)
        if(isRequestedAmountMismatch){
          if(multipleAddPaymentInfo?.length && approvalAmount < totalPaymentAmount){
            addToast(prJson.error.spentAmt,{ appearance: "info" });
            setIsLoading(false)
          }
         else{
        dispatch(fetchAsyncSendRequestUpdateApprovalDirectTaxTotalPayAmount
          ({ 
          id: editData._id,
          data:formData
         })).then(
          (res) => {
            if (res.payload && res.payload.updatedData) {
              const msg = prJson.confirm.resendRequest.replace("{generatedNum}", generatedNum);

              setIsEdit(true)
              setEditData(res.payload.updatedData)
              setPaymentStatus(0)
              addToast(msg, { appearance: "success" });
              closeModal('pending');
              setIsLoading(false)

            }
            else{
              addToast(res?.error.message, { appearance: "error" });
              setIsLoading(false)
  
            }
          }).catch((err)=>{
            addToast(err.message, { appearance: "error" });
            setIsLoading(false)
          });
        }
        }
      }
      else{
        setIsLoading(true)

        dispatch(fetchAsyncSendRequestApprovalDirectTaxTotalPayAmount(formData)).then((res) => {
            if (res.payload) {
              const msg = prJson.confirm.sendRequest.replace("{generatedNum}", generatedNum);
              addToast(msg, { appearance: "success" });
              setIsEdit(true)
              setEditData(res.payload)
              setPaymentStatus(0)
              closeModal('pending');
              setIsLoading(false)

            
            }
            else{
              addToast(res?.error.message, { appearance: "error" });
              setIsLoading(false)
  
            }
          }).catch((err)=>{
            addToast(err.message, { appearance: "error" });
            setIsLoading(false)
          });
      }
      
      
      }
  const handleTotalPayAmountIsApproved = (values)=>{
    const _id = editData._id;
    let formData = getFormData(values);

    if(editData.pyInfo?.sts === 0){
      const confirmMsg = prJson.confirm.approveAmt;
      const title = confirmMsg.replace("{approvalAmount}", formatAmountIndianRupees(approvalAmount)).replace("{generatedNum}", generatedNum);
      ConfirmationDialog({
        title: title,
        text: prJson.confirm.approveAction,  
        icon: "warning",
        confirmButtonText: "Approve",
        cancelButtonText: "Cancel",
        onConfirm: () => {
          setIsLoading(true)
          dispatch(fetchAsyncApproveDirectTaxTotalPayAmount({ 
            id: _id,
            data:formData
           })).then(
            (res) => {
              if (res.payload && res.payload.updatedData) {
                const msg = prJson.success.approved.replace("{generatedNum}", generatedNum);
                addToast(msg, { appearance: "success" });
                setIsLoading(false)
                closeModal('approved');
              }
            }
          );
        }
      })
    }
  
  }

  const handleTotalPayAmountIsRejected = ()=>{
    const _id = editData._id;
    
    if(editData.pyInfo?.sts === 0 ){
      const confirmMsg = prJson.confirm.rejectAmt;
      const title = confirmMsg.replace("{approvalAmount}", formatAmountIndianRupees(approvalAmount)).replace("{generatedNum}", generatedNum);
      ConfirmationDialog({
        title: title,
        text: prJson.confirm.rejectAction,
        icon: 'warning',
        confirmButtonText: 'Reject',
        cancelButtonText: 'Cancel',
        onConfirm: () => {
          setIsLoading(true)
          dispatch(fetchAsyncRejectDirectTaxTotalPayAmount({ 
            id: _id,
            data:{approveRejectRemarks:approveOrRejectRemarks}
           })).then(
            (res) => {
              if (res.payload && res.payload.updatedData) {
                const msg = prJson.success.rejected.replace("{generatedNum}", generatedNum);
                addToast(msg, { appearance: "success" });
                closeModal('rejected');
                setIsLoading(false)
              }
            }
          );
        },
      });
    }
  
  }
  
  
  const closeModelForm = () => {
    ConfirmationDialog({
      title: commonJson.close.confirm,
      text: commonJson.text.lost,
      icon: 'warning',
      confirmButtonText: 'Close',
      cancelButtonText: 'Cancel',
      onConfirm: () => {
        closeModal();
      },
    });
  };


  const deleteMultipleListItem = (listIndex)=>{
    ConfirmationDialog({
      title: prJson.confirm.deleteAmt,
      text: '',
      icon: 'warning',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      onConfirm: () => {
        const sendData = {
          id: editData._id,
          listIndex:listIndex
        };
        dispatch(fetchAsyncDeleteDirectTaxPaymentListItem(sendData)).then((res) => {
          if(res?.payload?.directTaxExpense?.pyInfo?.list && res?.payload?.directTaxExpense?.pyInfo?.list?.length){
            setMultipleAddPaymentInfo(res?.payload?.directTaxExpense?.pyInfo?.list)
          }
          else{
            setMultipleAddPaymentInfo(prevState => prevState.filter((_, i) => i !== listIndex));
          }
          addToast(prJson.success.spentAmt, { appearance: "success" });
        });
      },
    });
}

const deleteMultipleRefundListItem = (listIndex)=>{
  ConfirmationDialog({
    title: prJson.confirm.deleteRefundAmt,
    text: '',
    icon: 'warning',
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel',
    onConfirm: () => {
      const sendData = {
        id: editData._id,
        listIndex:listIndex
      };
      dispatch(fetchAsyncDeleteDirectTaxRefundListItem(sendData)).then((res) => {
        setMultipleAddRefundInfo(res?.payload?.directTaxExpense?.rfdInfo?.list)
        addToast(prJson.success.deleteRefund, { appearance: "success" });
      });
    },
  });
}
const handleRemarksChange = (e)=>{
  const value = e?.target?.value;
  const encoder = new TextEncoder(); // Default is 'utf-8'
  const byteLength = encoder.encode(value).length;
  if(byteLength <=128){

    setRemarksValue(value)
    setErrors({
      ...errors,
      remarks:''
    })
  }
  else{
    setErrors({
      ...errors,
      remarks:prJson.error.remarksLimit
    })
  }
}
useEffect(()=>{
  if(totalTax){
    setApprovalAmount(parseFloat(totalTax || 0 ) + parseFloat(roundOfAmount || 0))
  }
},[roundOfAmount])

useEffect(()=>{
  setTotalPaymentAmount(parseFloat(approvalAmount || 0))
},[approvalAmount])

const isRequestedAmountMismatch = useCallback(() => {
  return parseFloat(totalTax || 0) !== parseFloat(editData?.tlTx || 0) 
 }, [totalTax,editData]);
 
 
 const handleSelectTab = (k) => {
  setActiveTab(k);
};

const handleToggleRefundApplicable = () => {
  setIsRefund(!isRefund)
  if(!multipleAddRefundInfo?.length){
    setMultipleAddRefundInfo([""])
  }

};  
const hasAccess = useCallback(() => {
  return (role === "Admin" || role === "Manager" || role === 'Accountant') && paymentStatus === 1;
}, [role, paymentStatus]);

const handleAddAmount = (amt)=>{
  const parsedAmount = parseFloat(amt);
  if (!isNaN(parsedAmount)) {
    setRoundOfAmount(parsedAmount)
    // setApprovalAmount(Number(approvalAmount || 0) + parsedAmount);
  } 
}
  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={openModal}
        onClose={closeModelForm}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent
          top="0" // Position it at the top
          margin="0 auto" // Center it horizontally
          bottom="0"
          className="add-form-modal-content"
        >
          <div className="fixed-header">
            <ModalHeader className="expense-modal-header">
              Direct Tax - <span className="header-pr">{generatedNum}</span>  
            </ModalHeader>
            <ModalCloseButton />
          </div>
          {isLoading ?
            <SpinnerLoader/>
            :
          <ModalBody>
            <Form className="addForm" onSubmit={formik.handleSubmit}>
              <div className="form-card">
                <h5 className="mt-0">Direct Tax Details</h5>
                <Row className="mt-2">
                  <Col>
                    <Box display="flex" className="input-box">
                      <Form.Label>
                        Order Number <span className="span-star">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="No"
                        value={generatedNum && generatedNum}
                        disabled
                      />
                    </Box>
                  </Col>

                  <Col>
                    <Box display="flex" className="input-box">
                      <Form.Label>
                        Order - Month <span className="span-star">*</span>
                      </Form.Label>
                      <Box>
                      <DatePickerField
                        isDisabled={isEdit}
                        isBlink={isBlink}
                        name="orderMonth"
                        value={getPoMonth}
                        formate="MM-yyyy"
                        handleChange={(date)=>setGetPoMonth(date)}
                        isMonth={true}
                      />
                      
                      </Box>
                    </Box>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Box display="flex" className="input-box">
                      <Form.Label>
                        Order Date <span className="span-star">*</span>
                      </Form.Label>
                      <Box>
                      <DatePickerField
                        isBlink={isBlink}
                        name="orderDate"
                        isDisabled={isEdit}
                        value={selectedDate}
                        formate="dd-MMM-yyyy"
                        handleChange={(date)=>setSelectedDate(date)}
                        minDate={startOfMonth}
                        maxDate={endOfMonth}
                        isMonthDropdown={false}
                        isYearDropdown={false}
                      />
                      </Box>
                    </Box>
                  </Col>
                  <Col className="custom-select"></Col>
                </Row>

                <Row>
                  <Col>
                    <Box display="flex" className="input-box">
                      <Form.Label>
                        Receiver Name <span className="span-star">*</span>
                      </Form.Label>

                      <CustomSelect
                        options={receiverOption}
                        placeHolder={<div>Type or select...</div>}
                        onChange={(newValue) => setReceiverValue(newValue)}
                        isSearchable
                        onCreateOption={(e) => {
                          createNewFormOption(createOption(e), "receiver");
                        }}
                        onDeleteOption={(option) => {
                          deleteFormOption(option, "receiver");
                        }}
                        onEditOption={(option, newValue) => {
                          editFormOption(option, newValue, "receiver");
                        }}
                        defaultValue={receiverValue}
                        role={role}
                      />
                    </Box>
                    {errors?.receiverValue && !receiverValue && (
                      <p className="form_error">{errors?.receiverValue}</p>
                    )}
                  </Col>
                  <Col>
                    <Box display="flex" className="input-box">
                      <Form.Label>
                        Total Tax <span className="span-star">*</span>
                      </Form.Label>
                      <AmountInputField
                        name="totalTax"
                        placeholder="Total Tax"
                        value={totalTax}
                        handleChange={(value) => {
                          setTotalTax(value);
                          setApprovalAmount(Number(value || 0) + (roundOfAmount || 0));
                        }}
                        isInvalid={errors?.totalTax && !totalTax}
                      />
                    </Box>
                    {errors?.totalTax && !totalTax && (
                      <p className="form_error">{errors?.totalTax}</p>
                    )}
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>Remarks </Form.Label>
                    <TextAreaField
                      name="remarks"
                      value={remarksValue}
                      handleChange={(e) => handleRemarksChange(e)}
                      isInvalid={!!errors?.remarks}
                    />
                  </Box>
                  </Col>
                </Row>
              </div>
              <div className="form-card mt-3">
                <h5>Payment Information</h5>
                <Row >
                  <Col>
                  <Box display="flex" className="input-box">
                  <Form.Label>
                        Requested Amount <span className="span-star">*</span>
                      </Form.Label>
                      <AmountInputField
                        name="approvalAmount"
                        placeholder="Requested Amount"
                        isDisabled={true}
                        value={approvalAmount}
                        isInvalid={
                          (remainingAmount < 0 &&
                            approvalAmount <= totalPaymentAmount) ||
                          (!approvalAmount && errors?.approvalAmount)
                        }
                        InputGroupText={
                          <InputGroup.Text
                        className="quotation-upload"
                      >
                        {approvalAmount ?
                          <div className="add-amoun-button">
                            <AmountPopover roundOfAmount={roundOfAmount} addAmount={(value)=>{handleAddAmount(value)}}/>
                          </div>
                          :""
                        }
                        <Tooltip
                          label="Upload Quotation"
                          fontSize="md"
                          borderRadius="2xl"
                        >
                          <div
                            disabled={!approvalAmount}
                            className="position-relative"
                            onClick={() => {
                              approvalAmount && setOpenQuotation(!openQuotation);
                            }}
                          >
                            <FaFileUpload size={20} />
                            <span className="position-absolute top-0 start-100 translate-middle badge  bg-primary text-white">
                              {quotationData?.files || quotationData?.remarks
                                ? allQuotation?.length + 1
                                : allQuotation?.length || 0}
                            </span>
                          </div>
                        </Tooltip>
                      </InputGroup.Text>
                        }
                      />
                    </Box>
                    {((remainingAmount < 0 &&
                      approvalAmount <= totalPaymentAmount) ||
                      !approvalAmount) && (
                      <p className="form_error">{errors?.approvalAmount}</p>
                    )}
                  </Col>
                  {paymentStatus === 1 ? (
                    <Col>
                     <Box display="flex" className="input-box">
                      <Form.Label>Approved Amount</Form.Label>
                        <AmountInputField
                          isDisabled={true}
                          name="totalPayAmount"
                          placeholder="Total Amount"
                          value={totalPaymentAmount ? totalPaymentAmount : 0}
                        />                       
                     </Box>
                    </Col>
                  ) : (
                    <Col></Col>
                  )}
                </Row>
                {paymentStatus === 1 && (
                  <>
                    <Row>
                      <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Net Payable Amount</Form.Label>
                        <AmountInputField
                          isDisabled={true}
                          placeholder="Net Payable Amount"
                          value={remainingAmount ? remainingAmount : 0}
                          isInvalid={
                            remainingAmount < 0 &&
                            approvalAmount <= totalPaymentAmount
                          }
                          />   
                        </Box>
                        {remainingAmount < 0 &&
                          approvalAmount <= totalPaymentAmount && (
                            <p className="form_error">
                              Net payable amount cannot be negative. Please
                              revise the request with an increased requested
                              amount and resubmit for approval.
                            </p>
                          )}
                      </Col>
                      <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Total Spent Amount</Form.Label>
                        <AmountInputField
                          isDisabled={true}
                          name="totalPayAmount"
                          placeholder="Total Amount"
                          value={totalSpentAmount}
                        />   
                      </Box>
                      </Col>
                    </Row>
                  </>
                )}
              </div>
                <div>
                  <Tabs
                    defaultActiveKey={
                      activeTab 
                      ? activeTab 
                      :paymentStatus === 1
                        ? "spent"
                        : "Invoices" 
                    }
                    transition={false}
                    id="noanim-tab-example"
                    className="add-form-tabs exense-tabs"
                    onSelect={handleSelectTab}
                  >
                    {paymentStatus === 1 &&
                    <Tab eventKey="spent" title="Spent Amount" className="add-form-tab mx-0">
                    <div className="form-card">
                        
                    {paymentStatus === 1 &&
                  multipleAddPaymentInfo.map((item, index) => {
                    return (
                      <>
                        <PaymentInfoComponent
                          getData={(data) => {
                            handleUpdateMultiplePayData(data, index);
                          }}
                          autoCount={index}
                          paymentData={item}
                          editData={editData}
                          refreshEditData={refreshEditData}
                          isEdit={isEdit}
                          spentAmountError={spentAmountError}
                          expenseType="directTax"
                          deleteMultipleListItem={() =>
                            deleteMultipleListItem(index)
                          }
                          remainingAmount={remainingAmount}
                          role={role}
                        />
                      </>
                    );
                  })}
                  <Box display="flex" alignItems="center" >
                          <h5>Add Spent Amount</h5>
                          <Button
                            className="add-project mt-2 mx-1"
                            minWidth={0}
                            disabled={!remainingAmount}
                            onClick={() => {
                              handleMultiplePayInfo(
                                multipleAddPaymentInfo.length + 1
                              );
                            }}
                          >
                            <FaPlusCircle
                              className="add-project-icon"
                              size={15}
                            />
                          </Button>
                        </Box>
                    </div>
                    </Tab>
                    }
                    
                    <Tab
                    eventKey="Invoices"
                    title={
                      <div className="d-flex ">
                        Invoices
                        {multipleInvoiceData && multipleInvoiceData?.length > 0 && <FaCheck size={12} className="tab-icon" />}
                      </div>
                    }
                    className="add-form-tab"
                  >
                    {(activeTab === "Invoices" || paymentStatus !== 1) &&
                    <div className="form-card">
                      <Row>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label className="bill-number">
                              Bill Number #
                            </Form.Label>

                            <Box>
                              <Form.Control
                                type="text"
                                name="billNumber"
                                placeholder="Bill Number"
                                onChange={(e) => {
                                  setBillNumber(e.target.value);
                                }}
                                value={billNumber}
                              />
                            </Box>
                          </Box>
                        </Col>
                        <Col></Col>
                      </Row>
                      <div
                        className="form-card"
                        style={{ marginBottom: "0px" }}
                      >
                        <Box display="flex" alignItems="center">
                          <h5>Invoice</h5>
                          <Button
                            className="add-project mt-1"
                            onClick={() => {
                              handleInvoiceChange();
                            }}
                          >
                            <FaPlusCircle
                              className="add-project-icon"
                              size={15}
                            />
                          </Button>
                        </Box>
                        <Box display="flex">
                          <span
                            className=" mt-2"
                            style={{ color: "red", fontSize: "14px" }}
                          >
                            * File must be less then 2Mb
                          </span>
                          {multipleInvoiceData &&
                            multipleInvoiceData?.length >= 5 && (
                              <strong className="mx-4 mt-2">
                                Maximum 5 allowed
                              </strong>
                            )}
                        </Box>
                        {multipleInvoiceData &&
                          multipleInvoiceData?.map((item, index) => {
                            return (
                              <InvoiceComponent
                                key={`invoiceData-${index}`}
                                getInvoice={(data) =>
                                  handleUpdateInvoiceData(data, index)
                                }
                                selectedFile={item}
                                handleDelete={() => {
                                  handelDeleteInvoice(index);
                                }}
                                handleDeleteOnEdit={(key, spId) => {
                                  handleDeleteInvoiceOnEdit(key, spId);
                                }}
                                isEditing={isEdit}
                                addNewInvoiceOnEdit={(file) => {
                                  addNewInvoiceOnEdit(file, index);
                                }}
                                submitInvRemark={(value) => {
                                  addRemarkForInvoice(value, index);
                                }}
                                handleAddInvoiceRemarks={(value) => {
                                  handleAddInvoiceRemarks(value, index);
                                }}
                                role={role}
                              />
                            );
                          })}
                      </div>
                    </div>
                    }
                  </Tab>
                  
                    {(role === 'Admin' || role === 'Manager') && paymentStatus === 1 &&
                    <Tab
                      eventKey="excel"
                      title={
                        <div className="d-flex">
                          Excel{" "}
                          <span className="mx-1 mt-1">
                            <RiFileDownloadLine />
                          </span>
                        </div>
                      }
                      className="add-form-tab"
                    >
                      {activeTab === 'excel' &&
                      <DownloadExcelFile
                        prNo={generatedNum}
                        payAmount={totalPaymentAmount}
                        // merchantValue={resourceValue}
                        receiverOption={receiverOption}
                        expenseType="directTax"
                        role={role}
                      />
                      }
                    </Tab>
                    }
                    {(role === 'Admin' || role === 'Manager') && paymentStatus === 1 &&
                    <Tab
                      eventKey="refund"
                      title={
                          <div className="d-flex">
                          Refund
                            {isRefund &&
                            <FaCheck size={12}  className="tab-icon"/> 
                            }
                          </div>
                      }
                      disabled={!multipleAddPaymentInfo?.length}                    
                      className="add-form-tab"
                    >
                    {activeTab === 'refund' &&
                    <div className="form-card">
                    <Box display="flex" alignItems="center">
                        <h5>Refund Information</h5>
                          <Form.Check
                            className="mx-1 mt-2"
                            type="switch"
                            id="custom-switch"
                            checked={isRefund}
                            onChange={() => handleToggleRefundApplicable()}
                            />
                            
                        </Box>
                     
                      {isRefund && (
                        <Box>
                         

                          {multipleAddRefundInfo &&
                            multipleAddRefundInfo?.map((item, index) => {
                              return (
                                <RefundInfoListComponent
                                  key={`refundInfo-${index}`}
                                  getData={(data) => {
                                    handleUpdateMultipleRefundData(data, index);
                                  }}
                                  autoCount={index}
                                  paymentData={item}
                                  editData={editData}
                                  refreshEditData={refreshEditData}
                                  deleteMultipleListItem={() =>
                                    deleteMultipleRefundListItem(index)
                                  }
                                  remainingAmount={remainingAmount}
                                  refundAmountError={refundAmountError}
                                  expenseType="directTax"
                                  role={role}
                                />
                              );
                            })}
                        </Box>
                      )}
                      {isRefund && (
                       <Box display="flex" alignItems="center" >
                        <h5>Add Refund</h5>
                          
                             <Button
                                className="add-project mt-2"
                                onClick={() => {
                                  handleMultipleRefundInfo(
                                    multipleAddRefundInfo.length + 1
                                  );
                                }}
                                disabled={!isRefund}
                              >
                                <FaPlusCircle
                                  className="add-project-icon"
                                  size={15}
                                />
                              </Button>
                        </Box>
                      )}
                    </div>
                    }
                    </Tab>
                    }
                   
                  </Tabs>
                  </div>
              
              {(role === "Manager" || role === "Admin") &&
                activeList === "pending" &&
                isEdit &&
                paymentStatus === 0 && (
                  <>
                    <div className="form-card">
                      <h5>Approve OR Reject Remark</h5>
                      <Row>
                        <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>Remarks</Form.Label>
                          <TextAreaField
                            name="remarks"
                            value={approveOrRejectRemarks}
                            handleChange={(e) => setApproveOrRejectRemarks(e.target.value)}
                            isInvalid={!approveOrRejectRemarks && errors?.approveOrRejectRemarks}
                          />
                        </Box>
                          {!approveOrRejectRemarks && (
                            <p className="form_error">
                              {errors?.approveOrRejectRemarks}
                            </p>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </>
                )}
              <Row className="mt-4">
                {(role === "Manager" || role === "Admin") &&
                activeList === "pending" &&
                isEdit &&
                paymentStatus === 0 ? (
                  <ModalFooter
                    style={{ alignItems: "center", justifyContent: "center" }}
                  >
                    {paymentStatus !== 1 && (
                      <div className="d-flex">
                        <SubmitButton
                          handleClick={() => {
                            handleTotalPayAmountIsApproved(formik.values);
                          }}
                          customClass="me-2"
                          isDisabled={totalPaymentAmount === null ? true : false}
                          btnTxt="Approve"
                        />
                        <SubmitButton
                          handleClick={() => {
                            handleTotalPayAmountIsRejected();
                          }}
                          isDisabled={totalPaymentAmount === null ? true : false}
                          btnTxt="Reject"
                        />
                      </div>
                    )}
                  </ModalFooter>
                ) : (
                  <ModalFooter>
                    {(paymentStatus === 0) ||
                    remainingAmount < 0 ||
                    parseFloat(totalTax) !==
                      parseFloat(editData?.tlTx) ?
                        <SubmitButton
                          handleClick={() => {
                            handleAmountApproveBtn(formik.values);
                          }}
                          isDisabled={totalPaymentAmount === null ? true : false}
                          btnTxt="Send Request"
                        /> : 
                          <SubmitButton
                            handleClick={() => {
                              setCompareDataModal(true);
                            }}
                            btnTxt="Submit"
                            type="submit"
                          /> 
                    }
                  </ModalFooter>
                )}
              </Row>
            </Form>
          </ModalBody>
          }
        </ModalContent>
      </Modal>
      {compareDataModal && comparingData && (
        <DirectTaxDataChangeModal
          openModal={compareDataModal}
          closeModal={closeComparedDataModal}
          editData={editData}
          currentData={comparingData}
          isConfirmed={() => {
            submitUpdateData(comparingData, editData);
          }}
          type={"direct-tax"}
          role={role}

        />
      )}
      {openQuotation && (
        <QuotationForm
          isOpen={openQuotation}
          closeModal={() => {
            handleCloseQuotation();
          }}
          requestedAmount={approvalAmount}
          handleData={(data) => handleQuotationData(data)}
          uploadedData={quotationData}
          expenseId={editData?._id || ""}
          allQuotation={allQuotation}
        />
      )}
    </>
  );
};

export default DirectTax;
